import { Component, OnInit } from '@angular/core';
import { Card } from '../../../../model/card';
import { PromptService } from '../../../../services/prompt/prompt.service';
import { MzToastService } from 'ng2-materialize';
import { CardsService } from '../../../../resources/cards/cards.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { AgreementService } from '../../../../resources/agreement/agreement.service';

@Component({
  selector: 'app-cards-summary',
  templateUrl: './cards-summary.component.html',
  styleUrls: ['./cards-summary.component.scss']
})
export class CardsSummaryComponent implements OnInit {

  cards: Card[];
  loading = true;
  p: number;
  agreement_type: number;

  constructor(private cardsService: CardsService,
              private spinner: SpinnerService,
              private toast: MzToastService,
              private prompt: PromptService,
              private agreement: AgreementService) {
  }

  ngOnInit() {
    this.p = this.cardsService.page;
    this.cardsService.query()
      .map((data) => {
        return [...data.map((card) => {

          card.isEditable = true;

          if (card.status === 6) {
            card.card_no = 'wnioskowana';
            card.isEditable = false;
            card.active = false;
          }

          if (card.status === 7) {
            card.card_no = 'wniosek odrzucony';
            card.isEditable = false;
            card.active = false;
          }

          return new Card(card);
        })];
      })
      .subscribe((res) => {
        this.loading = false;
        this.cards = res;
        this.agreement_type = this.agreement.type;
      });
  }

  changePage(page) {
    this.cardsService.page = page;
    this.p = page;
  }

  statusChange(card) {
    this.loading = true;
    const update_card = new Card(card);
    this.cardsService.update(update_card).subscribe(() => {
        this.loading = false;
        this.toast.show('Zmieniono status karty', 2000, 'success');
      },
      () => {
        this.loading = false;
        card.active = false;
        this.toast.show('Nie można zmienić statusu karty', 2000, 'error');
      });
  }

  removeCard(card: Card) {
    let spinner;
    this.prompt.confirm(`Usunąć kartę nr ${card.card_no}?`)
      .switchMap((v) => {
        if (v) {
          spinner = this.spinner.show('Usuwam...');
          return this.cardsService.destroy(card.id);
        } else {
          return Observable.empty();
        }
      })
      .subscribe(() => {
        this.toast.show('Usunięto kartę', 2000, 'success');
        spinner.close();
        this.ngOnInit();
      }, () => {
        spinner.close();
        this.toast.show('Nie można usunąć karty', 2000, 'error');
      });

  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/cards/cards-summary/cards-summary.component.ts